import { render } from "./Rappresentante.vue?vue&type=template&id=41179528"
import script from "./Rappresentante.vue?vue&type=script&lang=js"
export * from "./Rappresentante.vue?vue&type=script&lang=js"

import "./Rappresentante.vue?vue&type=style&index=0&id=41179528&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__